<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  template: { type: Object, required: true },
});
const tools = defineModel({ type: Array, default: () => [] });
const { t } = useI18n();
</script>

<template>
  <section class="space-y-4 rounded-2xl border border-n-weak bg-n-solid-2 p-6">
    <div class="space-y-1">
      <h2 class="text-base font-semibold text-n-slate-12">
        {{ t('AI_AGENTS.TEMPLATE_TOOLS.TITLE') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ t('AI_AGENTS.TEMPLATE_TOOLS.DESCRIPTION') }}
      </p>
    </div>
    <div class="space-y-2">
      <h3 class="text-sm font-medium text-n-slate-12">
        {{ t('AI_AGENTS.TEMPLATE_TOOLS.INCLUDED') }}
      </h3>
      <ul class="flex flex-wrap gap-2">
        <li
          v-for="tool in template.recommended_tools"
          :key="tool"
          class="rounded-full bg-n-alpha-2 px-3 py-1 text-sm text-n-slate-12"
        >
          {{ t(`AI_AGENTS.TEMPLATE_TOOLS.ITEMS.${tool}.LABEL`) }}
        </li>
      </ul>
    </div>
    <div class="space-y-3">
      <h3 class="text-sm font-medium text-n-slate-12">
        {{ t('AI_AGENTS.TEMPLATE_TOOLS.OPTIONAL') }}
      </h3>
      <label
        v-for="tool in template.optional_tools"
        :key="tool"
        class="flex cursor-pointer items-start gap-3 rounded-lg border border-n-weak p-3"
      >
        <input v-model="tools" type="checkbox" :value="tool" class="mt-1" />
        <span class="space-y-1">
          <span class="block text-sm font-medium text-n-slate-12">
            {{ t(`AI_AGENTS.TEMPLATE_TOOLS.ITEMS.${tool}.LABEL`) }}
          </span>
          <span class="block text-xs text-n-slate-11">
            {{ t(`AI_AGENTS.TEMPLATE_TOOLS.ITEMS.${tool}.DESCRIPTION`) }}
          </span>
        </span>
      </label>
    </div>
    <p class="text-xs text-n-slate-11">
      {{ t('AI_AGENTS.TEMPLATE_TOOLS.INTEGRATIONS_HINT') }}
    </p>
  </section>
</template>
